(() => {
  const cache = new Map();

  const loadProduct = (url) => {
    if (!cache.has(url)) {
      cache.set(url, fetch(`${url}.js`).then((response) => response.json()));
    }
    return cache.get(url);
  };

  const renderSelect = (bar) => {
    const info = bar.querySelector(".the-buy-bar");
    if (!info || info.querySelector("[data-buy-bar-variant]")) return;

    loadProduct(bar.dataset.url).then((product) => {
      if (product.has_only_default_variant || product.variants.length < 2) return;
      if (info.querySelector("[data-buy-bar-variant]")) return;

      const idInput = info.querySelector('input[name="id"]');
      const currentId = idInput ? idInput.value : "";
      const soldOut = (window.variantStrings && window.variantStrings.soldOut) || "Sold out";

      const wrapper = document.createElement("div");
      wrapper.className = "buy-bar-variant";

      const select = document.createElement("select");
      select.className = "buy-bar-variant__select";
      select.setAttribute("data-buy-bar-variant", "");
      select.setAttribute("aria-label", product.options.join(" / "));

      product.variants.forEach((variant) => {
        const label = variant.available ? variant.title : `${variant.title} (${soldOut})`;
        const option = new Option(label, variant.id, false, String(variant.id) === String(currentId));
        option.disabled = !variant.available;
        option.dataset.options = JSON.stringify(variant.options);
        select.add(option);
      });

      wrapper.append(select);
      info.insertBefore(wrapper, info.querySelector("product-form"));
    });
  };

  const initBar = (bar) => {
    if (bar.dataset.variantSelectReady) return;
    bar.dataset.variantSelectReady = "true";

    const info = bar.querySelector(".the-buy-bar");
    if (info) {
      new MutationObserver(() => renderSelect(bar)).observe(info, { childList: true });
    }

    const run = () => renderSelect(bar);
    if ("requestIdleCallback" in window) {
      requestIdleCallback(run, { timeout: 2000 });
    } else {
      setTimeout(run, 200);
    }
  };

  const init = (root = document) => {
    root.querySelectorAll("product-buy-bar").forEach(initBar);
  };

  document.addEventListener("change", (event) => {
    const select = event.target.closest("[data-buy-bar-variant]");
    if (!select) return;

    const bar = select.closest("product-buy-bar");
    const section = (bar.dataset.productFormId || "").replace("product-form-", "");
    const picker = document.getElementById(`variant-selects-${section}`);
    const values = JSON.parse(select.selectedOptions[0].dataset.options || "[]");
    let changedInput = null;

    if (picker) {
      values.forEach((value, index) => {
        const input = picker.querySelector(
          `.option-buttons[data-option-position="${index + 1}"] input[value="${CSS.escape(value)}"]`
        );
        if (input && !input.checked) {
          input.checked = true;
          changedInput = input;
        }
      });
    }

    if (changedInput) {
      changedInput.dispatchEvent(new Event("change", { bubbles: true }));
    } else {
      const idInput = bar.querySelector('input[name="id"]');
      if (idInput) idInput.value = select.value;
    }
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();